import { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DateBox from 'devextreme-react/date-box';
import { NumericFormat } from 'react-number-format';
import { FileSelectDialog } from '../../../common/SharedComponents';
import { ConfirmModal } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faDownload, faTrashCan } from '@fortawesome/free-solid-svg-icons';

export const AppraisalDialog = ({ isOpen, appraisal, onSubmit, onCancel }) => {
    if (!isOpen || !appraisal) {
        return;
    }

    const fileUploadOptions = {
        isOpen: false,
        maxFiles: 5,
        isReplace: false,
        typeName: '',
    };
    const [fileSelectOptions, set_fileSelectOptions] = useState(fileUploadOptions);
    const [appraisedDate, set_appraisedDate] = useState('');
    const [appraisedValue, set_appraisedValue] = useState('');
    const [file, set_file] = useState(null);
    const [openConfirmOverwriteModal, set_openConfirmOverwriteModal] = useState(false);

    useEffect(() => {
        set_file(null);
        if (!appraisal) {
            return;
        }
        set_appraisedDate(appraisal.appraisedDate);
        set_appraisedValue(appraisal.appraisedValue);
        set_file(appraisal.fileToUpload);
    }, [appraisal]);

    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        formRow: { marginBottom: '0' },
        formColumn: { paddingBottom: '3px' },
        iconCancel: { color: 'darkred', cursor: 'pointer' },
    };

    // const styles = {

    //   iconContainer: { paddingLeft: '0', paddingRight: '0', paddingBottom: '3px' },
    //   iconYes: { color: 'mediumblue', cursor: 'pointer' },
    //   iconNo: { color: 'silver', cursor: 'not-allowed' },
    //   iconCancel: { color: 'darkred', cursor: 'pointer' },
    // };

    const onSubmitClick = () => {
        const model = {
            id: appraisal.id,
            guid: appraisal.guid,
            appraisedDate: new Date(appraisedDate).toISOString().split('T')[0],
            appraisedValue,
            url: appraisal.url,
            fileName: file?.name ?? appraisal.fileName,
            fileToUpload: file,
        };
        onSubmit && onSubmit(model);
    };

    const onCancelClick = () => {
        onCancel && onCancel();
    };

    const onFileSelectSubmit = (id, selectedFiles) => {
        if (!selectedFiles || selectedFiles.length === 0) {
            return;
        }

        const newFile = selectedFiles[0];
        set_file(newFile);
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
    };

    const onFileSelectCancel = () => {
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
    };

    const uploadAppraisalFile = () => {
        const options = {
            ownerId: null,
            isOpen: true,
            maxFiles: 1,
        };
        set_fileSelectOptions(options);
    };

    const confirmOverwrite = () => {
        set_openConfirmOverwriteModal(true);
    };

    const onOverwriteConfirm = async () => {
        set_openConfirmOverwriteModal(false);
        uploadAppraisalFile();
    };

    const onOverwriteFileCancel = () => {
        set_openConfirmOverwriteModal(false);
    };

    const onDownload = async (e, url) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
    };

    const onRemoveTempFile = () => {
        if (!file) {
            return;
        }

        set_file(null);
    };

    return (
        <>
            <Dialog
                maxWidth='md'
                open={isOpen}
                onClose={onCancelClick}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '500px', overflow: 'unset' }}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>Appraisal Details</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={onCancelClick}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <form className='standard-form'>
                                <div
                                    className='main-content no-search'
                                    style={{ padding: '10px', width: '100%' }}
                                >
                                    <div
                                        className='row'
                                        style={styles.formRow}
                                    >
                                        <div
                                            className='columns small-12 large-5'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='appraisedDate'>
                                                Appraised Date <span className='req'>*</span>
                                            </label>
                                            <DateBox
                                                id='appraisedDate'
                                                value={appraisedDate}
                                                onValueChange={set_appraisedDate}
                                                required={true}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-4'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='appraisedValue'>
                                                Appraised Value <span className='req'>*</span>
                                            </label>
                                            <NumericFormat
                                                thousandSeparator=','
                                                prefix='$'
                                                id='appraisedValue'
                                                name='appraisedValue'
                                                placeholder='$'
                                                value={appraisedValue}
                                                decimalScale={2}
                                                allowNegative={false}
                                                onValueChange={(values) => {
                                                    set_appraisedValue(values.floatValue);
                                                }}
                                                required={noteDate}
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <br />
                                    <div
                                        className='row'
                                        style={styles.formRow}
                                    >
                                        <div
                                            className='columns small-12 large-12'
                                            style={styles.formColumn}
                                        >
                                            {appraisal.url && !file && (
                                                <button
                                                    type='button'
                                                    onClick={(event) => onDownload(event, appraisal.url)}
                                                    className='link'
                                                    title='Download File'
                                                    style={{ margin: '0' }}
                                                >
                                                    <FontAwesomeIcon icon={faDownload} />
                                                    &nbsp;&nbsp;
                                                    {appraisal.fileName}
                                                </button>
                                            )}
                                            {!appraisal.url && (
                                                <span>
                                                    <label>No file available</label>
                                                </span>
                                            )}
                                            {file && (
                                                <div>
                                                    <span>{file.name}</span>
                                                    &nbsp;
                                                    <span>
                                                        <FontAwesomeIcon
                                                            icon={faTrashCan}
                                                            style={styles.iconCancel}
                                                            title={'Cancel File Upload'}
                                                            onClick={() => {
                                                                onRemoveTempFile();
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            )}
                                            <div>
                                                <button
                                                    type='button'
                                                    className='button hollow'
                                                    title='Upload new Appraisal file'
                                                    onClick={appraisal.url ? confirmOverwrite : uploadAppraisalFile}
                                                >
                                                    {appraisal.url || file ? 'Replace File' : 'Upload File'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='button-footer'
                                    style={styles.buttonContainer}
                                >
                                    <button
                                        type='button'
                                        className='button'
                                        onClick={onSubmitClick}
                                        disabled={!appraisedDate || !appraisedValue}
                                    >
                                        Submit
                                    </button>
                                    &nbsp;
                                    <button
                                        type='button'
                                        className='button hollow'
                                        onClick={onCancelClick}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <FileSelectDialog
                options={fileSelectOptions}
                onSubmit={onFileSelectSubmit}
                onCancel={onFileSelectCancel}
            />
            <ConfirmModal
                isOpen={openConfirmOverwriteModal}
                text={'This will overwrite the existing file! Are you sure?'}
                confirmCallback={onOverwriteConfirm}
                cancelCallback={onOverwriteFileCancel}
            />
        </>
    );
};
